@use '../../../../app/styles/common/mixins';

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spasing20);
  padding: var(--spasing20) 0;
}

.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.illustration {
  display: block;
  width: 80px;
  height: 80px;
}

.message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
}

.title {
  @include mixins.heading-secondary-200;

  margin: 0;
  color: var(--fg-primary);
}

.text {
  @include mixins.caption-primary-450;

  margin: 0;
  color: var(--fg-secondary);
}

.sectionTitle {
  margin-top: var(--spasing24);
}
